export default __webpack_public_path__ + "media/images/2012-184f0bb32a4e125650854366838f7644.png";